/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business ユーザー×ロール管理用の react-query フック群。ユーザー権限管理タブで使用。
 * @graph-connects /permissions/user-roles [calls] ユーザーロール一覧取得・更新
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { permissionsApi } from '../lib/permissions-api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { SetUserRolesInput } from '../types/permissions.js';

/** @graph-connects none */
export function useUserRoles() {
  return useQuery({
    queryKey: queryKeys.permissions.userRoles,
    queryFn: permissionsApi.listUserRoles,
  });
}

/** @graph-connects none */
export function useSetUserRoles() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SetUserRolesInput) => permissionsApi.setUserRoles(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.permissions.userRoles });
      void queryClient.invalidateQueries({ queryKey: queryKeys.permissions.me });
    },
  });
}
